import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { onLoadingFail, onLoadingStart, onLoadingSuccess } from './userFarmSlice';

const orthophotoAdapter = createEntityAdapter({
  selectId: (orthophoto) => orthophoto.orthophoto_id,
});

const orthophotoSlice = createSlice({
  name: 'orthophotoReducer',
  initialState: orthophotoAdapter.getInitialState({
    loading: false,
    error: undefined,
    loaded: false,
  }),
  reducers: {
    onLoadingOrthophotoStart: onLoadingStart,
    onLoadingOrthophotoFail: onLoadingFail,
    getOrthophotosSuccess: (state, { payload: orthophotos }) => {
      orthophotoAdapter.setAll(state, orthophotos);
      onLoadingSuccess(state);
    },
    addOrthophotoSuccess: orthophotoAdapter.addOne,
    updateOrthophotoSuccess: orthophotoAdapter.updateOne,
    deleteOrthophotoSuccess: orthophotoAdapter.removeOne,
  },
});

export const {
  onLoadingOrthophotoStart,
  onLoadingOrthophotoFail,
  getOrthophotosSuccess,
  addOrthophotoSuccess,
  updateOrthophotoSuccess,
  deleteOrthophotoSuccess,
} = orthophotoSlice.actions;
export default orthophotoSlice.reducer;

export const orthophotoReducerSelector = (state) =>
  state.entitiesReducer[orthophotoSlice.name];

const orthophotoSelectors = orthophotoAdapter.getSelectors(
  (state) => state.entitiesReducer[orthophotoSlice.name],
);

export const orthophotoEntitiesSelector = orthophotoSelectors.selectEntities;
export const orthophotosSelector = orthophotoSelectors.selectAll;

export const orthophotosByFarmSelector = createSelector(
  [orthophotosSelector, (_state, farm_id) => farm_id],
  (orthophotos, farm_id) => orthophotos.filter((o) => o.farm_id === farm_id && !o.deleted),
);

export const orthophotosByLocationSelector = createSelector(
  [orthophotosSelector, (_state, location_id) => location_id],
  (orthophotos, location_id) =>
    orthophotos.filter((o) => o.location_id === location_id && !o.deleted),
);

export const visibleOrthophotosSelector = createSelector([orthophotosSelector], (orthophotos) =>
  orthophotos.filter((o) => o.visible && !o.deleted),
);

export const orthophotoStatusSelector = createSelector(
  [orthophotoReducerSelector],
  ({ loading, error, loaded }) => {
    return { loading, error, loaded };
  },
);
